"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _apiClient = _interopRequireDefault(require("hub-http/clients/apiClient"));

var API_BASE = 'content/api/v4/pages/supported-languages';

var SupportedLanguagesAPI =
/*#__PURE__*/
function () {
  function SupportedLanguagesAPI() {
    (0, _classCallCheck2.default)(this, SupportedLanguagesAPI);
  }

  (0, _createClass2.default)(SupportedLanguagesAPI, null, [{
    key: "get",
    value: function get() {
      return _apiClient.default.get(API_BASE);
    }
  }]);
  return SupportedLanguagesAPI;
}();

exports.default = SupportedLanguagesAPI;
module.exports = exports.default;